export const MAX_QUIZ_QUESTIONS = 10;
export const MIN_QUIZ_ANSWERS = 2;
export const MAX_QUIZ_ANSWERS = 5;
export const QUIZ_QUESTION_INVALID_MESSAGE =
  "A question needs text, 2 to 5 answers and one correct answer.";
